webpackJsonp([47149683451154],{

/***/ 1067:
/***/ (function(module, exports) {

	module.exports = {"description":"","displayName":"Button","methods":[],"props":{"disabled":{"type":{"name":"bool"},"required":false,"description":"Disable or enable button","defaultValue":{"value":"false","computed":false}},"loading":{"type":{"name":"bool"},"required":false,"description":"Show loading mode","defaultValue":{"value":"false","computed":false}},"outline":{"type":{"name":"bool"},"required":false,"description":"Define if button is only with border","defaultValue":{"value":"false","computed":false}},"active":{"type":{"name":"bool"},"required":false,"description":"Define if button is active","defaultValue":{"value":"false","computed":false}},"loadingClass":{"type":{"name":"string"},"required":false,"description":"Class to show loading indicator","defaultValue":{"value":"'fa fa-circle-o-notch fa-spin'","computed":false}},"className":{"type":{"name":"string"},"required":false,"description":"Class to apply to button","defaultValue":{"value":"''","computed":false}},"style":{"type":{"name":"objectOf","value":{"name":"any"}},"required":false,"description":"Css style applied to the component","defaultValue":{"value":"{}","computed":false}},"ariaLabel":{"type":{"name":"string"},"required":false,"description":"Aria label of the button","defaultValue":{"value":"''","computed":false}},"tooltip":{"type":{"name":"string"},"required":false,"description":"Button tooltip","defaultValue":{"value":"''","computed":false}},"size":{"type":{"name":"string"},"required":false,"description":"Button size. Can be <code>'lg'</code>, <code>'sm'</code>","defaultValue":{"value":"''","computed":false}},"type":{"type":{"name":"string"},"required":false,"description":"Type of the button","defaultValue":{"value":"'button'","computed":false}},"color":{"type":{"name":"string"},"required":false,"description":"Color to apply to button","defaultValue":{"value":"'light'","computed":false}},"children":{"type":{"name":"union","value":[{"name":"arrayOf","value":{"name":"node"}},{"name":"node"}]},"required":false,"description":"Button styles","defaultValue":{"value":"null","computed":false}},"onClick":{"type":{"name":"func"},"required":false,"description":"Called when button is clicked","defaultValue":{"value":"() => {}","computed":false}}},"filename":"/components/Button/Button.jsx"}

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(5);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _DetailsComponent = __webpack_require__(6);
	
	var _DetailsComponent2 = _interopRequireDefault(_DetailsComponent);
	
	var _button = __webpack_require__(497);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _map = __webpack_require__(1067);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComponentView = function (_React$Component) {
	  _inherits(ComponentView, _React$Component);
	
	  function ComponentView() {
	    _classCallCheck(this, ComponentView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ComponentView.prototype.render = function render() {
	    return _react2.default.createElement(
	      _main2.default,
	      { pagePushedFunction: this.handlepushedPageLayout },
	      _button2.default && _react2.default.createElement(_DetailsComponent2.default, {
	        name: _button2.default.name,
	        linkGithub: 'https://github.com/front10/landing-page-book/tree/master/src/components/Button',
	        description: _button2.default.summary,
	        stories: _button2.default.stories,
	        importCode: _button2.default.import,
	        withStyles: _button2.default.withStyles,
	        extractProps: _button2.default.extractProps,
	        propsDescription: _map2.default.props
	      })
	    );
	  };
	
	  return ComponentView;
	}(_react2.default.Component);
	
	exports.default = ComponentView;
	module.exports = exports['default'];

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  name: 'Button',
	  summary: '<code class="code">Buttons</code> is based on <code class="code">Bootstrap</code> buttons and includes several predefined button styles, \n  each serving its own <code class="code">semantic</code> purpose, with a few extras thrown in for more control.',
	  import: 'import { ThemeSelector } from \'../../../addons/ThemeSwitcher\';\n    import DetailsComponent from \'../../../../storybook-utils/components/DetailsComponent\';\n    import { Navbar, Footer } from \'../../../components\';',
	  withStyles: true,
	  stories: [{
	    name: 'Basic',
	    summary: '',
	    code: '<Button color="primary" tooltip="This is a tooltip">\n  <Icon icon="fa fa-home" /> Home\n</Button>',
	    tabsActive: ['code']
	  }, {
	    name: 'Buttons',
	    summary: '',
	    code: '<div>\n  <Button marginRight="1" color="primary"> Primary </Button>\n  <Button marginRight="1" color="secondary"> Secondary </Button>\n  <Button marginRight="1" color="success"> Success </Button>\n  <Button marginRight="1" color="danger"> Danger </Button>\n  <Button marginRight="1" color="warning"> Warning </Button>\n  <Button marginRight="1" color="info"> Info </Button>\n  <Button marginRight="1" color="light"> Light </Button>\n  <Button marginRight="1" color="dark"> Dark </Button>\n  <Button marginRight="1" color="link"> Link </Button>\n</div>',
	    tabsActive: []
	  }, {
	    name: 'Buttons Outline',
	    summary: '',
	    code: '<>\n  <Button marginRight="1" outline color="primary">Primary</Button>\n  <Button marginRight="1" outline color="secondary">Secondary</Button>\n  <Button marginRight="1" outline color="success">Success</Button>\n  <Button marginRight="1" outline color="danger">Danger</Button>\n  <Button marginRight="1" outline color="warning">Warning</Button>\n  <Button marginRight="1" outline color="info">Info</Button>\n  <Button marginRight="1" outline color="light">Light</Button>\n  <Button marginRight="1" outline color="dark">Dark</Button>\n  <Button marginRight="1" outline color="link">Link</Button>\n</>',
	    tabsActive: []
	  }, {
	    name: 'Size (small)',
	    summary: '',
	    code: '<>\n  <Button marginRight="1" color="primary" size="sm">Small button</Button>\n  <Button marginRight="1" color="secondary" size="sm">Small button</Button>\n</>',
	    tabsActive: []
	  }, {
	    name: 'Size (large)',
	    summary: '',
	    code: '<>\n  <Button marginRight="1" color="primary" size="lg">Large button</Button>\n  <Button marginRight="1" color="secondary" size="lg">Large button</Button>\n</>',
	    tabsActive: []
	  }, {
	    name: 'Desactivate state',
	    summary: '',
	    code: '<>\n  <Button marginRight="1" color="primary" disabled>Disabled button</Button>\n  <Button marginRight="1" color="secondary" disabled>Disabled button</Button>\n</>',
	    tabsActive: []
	  }, {
	    name: 'Active state',
	    summary: '',
	    code: '<>\n  <Button marginRight="1" color="primary" active>Active button</Button>\n  <Button marginRight="1" color="secondary" active>Active button</Button>\n</>',
	    tabsActive: []
	  }]
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-components-button-js-70a31bbf4d2c799f3f07.js